import { useMemo } from 'react';

import { useCurrentUser } from '@qualio/ui-components';

import { isNotFoundError } from '../utils/errorUtils';
import { getUserTZ } from '../utils/userUtils';
import { useEventActionLog } from './useEventActionLog';
import { useEventDetails } from './useEventDetails';
import { useEventQris } from './useEventQris';
import { useTags } from './useTags';
import { useUsers } from './useUsers';

export const useEventPageData = (eventId: number) => {
  const { userId } = useCurrentUser();

  const eventQuery = useEventDetails(eventId);
  const qris = useEventQris(eventQuery.data);
  const actionLogQuery = useEventActionLog(eventId);
  const { data: usersData } = useUsers();
  const { data: tagsData } = useTags();
  const userTZ = useMemo(() => getUserTZ(userId, usersData ?? []), [userId, usersData]);

  return {
    eventData: eventQuery.data,
    isFetching: eventQuery.isFetching,
    isEventError: eventQuery.isError,
    isEventNotFound: eventQuery.isError && isNotFoundError(eventQuery.error),
    refetch: eventQuery.refetch,
    isEventActionLogListFetching: actionLogQuery.isFetching,
    usersData,
    tagsData,
    userTZ,
    suppliersData: qris.suppliersData,
    relatedDocumentsData: qris.relatedDocumentsData,
    relatedEventsData: qris.relatedEventsData,
    eventActionLogData: actionLogQuery.data?.[0],
    alertFetchingRelatedContent: qris.isError,
  };
};
